import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var PujasService = /** @class */ (function () {
    function PujasService(httpClient) {
        this.httpClient = httpClient;
        this.baseUrl = environment.baseUrl;
    }
    PujasService.prototype.postPuja = function (idLote, monto) {
        return this.httpClient.post(this.baseUrl + '/puja/' + idLote + '/' + monto, {});
    };
    PujasService.prototype.postCompraDirecta = function (idLote, monto) {
        return this.httpClient.post(this.baseUrl + '/compra-directa/' + idLote + '/' + monto, {});
    };
    PujasService.prototype.getPujas = function (idLote) {
        return this.httpClient.get(this.baseUrl + '/pujas/' + idLote);
    };
    PujasService.ngInjectableDef = i0.defineInjectable({ factory: function PujasService_Factory() { return new PujasService(i0.inject(i1.HttpClient)); }, token: PujasService, providedIn: "root" });
    return PujasService;
}());
export { PujasService };
